/**
 * Version values are injected into built artifacts post-build by the CI pipeline.
 * Do not edit manually.
 *
 * During CI: nx run-many builds all web apps in parallel with these placeholders.
 * After build: injectVersionIntoBuiltArtifact() replaces them in the dist JS files.
 * Locally: displays '__APP_VERSION__' / '__BUILD_NUMBER__' (or run the local inject script).
 */
export function getAppVersionInfo() {
  const versionName = '__APP_VERSION__';
  const buildNumber = '__BUILD_NUMBER__';

  return {
    versionName,
    buildNumber,
  };
}
